export default [
  {
    name: 'setting-rsvp',
    path: '/settings/rsvp',
    component: () => import(/* webpackChunkName: "event" */ './Rsvp.vue'),
    meta: {
      showNavbar: true,
      title: 'Parâmetros do RSVP',
      icon: 'dvr',
      label: 'Configurações gerais',
      roles: ['Admin']
    }
  }
]
